import { Typo } from "../../Typo";

/**
 * Fallback shown when a banner's type isn't one we can render. The label is
 * injected so the shared component stays locale-agnostic (portal passes a
 * translated string; backoffice relies on the English default).
 */
export const UnknownAssetPreview = ({
  label = "Something went wrong",
}: {
  label?: string;
}) => (
  <div className="flex h-full w-full items-center justify-center text-center">
    <Typo type="bodyXS" textColor="text-text-secondary">
      {label}
    </Typo>
  </div>
);
